/**
 * Root and Auth Layout Routes
 *
 * Defines the root route and authenticated layout that protects child routes.
 */

import { createAuthBeforeLoad } from '@bb/session-manager';
import { createRootRoute, createRoute } from '@tanstack/react-router';
import { BBSpinner } from '../components/BBSpinner/BBSpinner';
import AuthenticatedLayout from '../layouts/AuthenticatedLayout';
import RootLayout from '../layouts/RootLayout';

/**
 * Pending component shown while async beforeLoad is executing (permission fetch).
 */
const AuthPendingComponent = () => <BBSpinner isCentered message="Loading..." />;

/**
 * Root route - wraps entire app
 */
export const rootRoute = createRootRoute({
  component: RootLayout,
});

/**
 * Authenticated layout route
 * All /bbweb/* routes go through this auth check
 * pendingComponent shows while permission fetch is in progress
 */
export const authLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bbweb',
  beforeLoad: createAuthBeforeLoad({ loginPath: '/bbweb/login' }),
  pendingComponent: AuthPendingComponent,
  component: AuthenticatedLayout,
});
